<template>
    <div>
        <!-- 交通管制标记 -->
        <LVector :zIndex="30" :hoverFeature="hoverFeature" :selectFeature="selectFeature">
            <template v-for="item in caseCanvasList">
                <LPointFeature v-if="item.geometryType === 'Point'"
                    :key="item.id + 'draw-point'" :id="item.id" :defaultStyle="drawPointStyle(item.name)"
                    :latitude="item.geometry[1]" :longitude="item.geometry[0]"
                    :overlayOffset="[0, -40]" :obj="item" />
            </template>
        </LVector>
        <LVector :zIndex="29" :hoverFeature="hoverFeature" :selectFeature="selectFeature">
            <template v-for="item in caseCanvasList">
                <LPolygonFeature v-if="item.geometryType === 'Polygon'"
                    :key="item.id + 'draw-Polygon'" :id="item.id" :defaultStyle="drawPolygonStyle(item)"
                    :positions="[item.geometry]" :overlayOffset="[0, -40]" :obj="item"></LPolygonFeature>
                <LLineFeature v-if="item.mark === '道路' && item.type === 5"
                    :pointData="item.geometry" :key="item.id + '2d-draw-LineString-道路'" :id="item.id"
                    :obj="item" :overlayOffset="[0, -40]" :defaultStyle="roadStyle" :isStyles="true"></LLineFeature>
                <LCircleFeature v-if="item.mark === '圆形'" :center="item.positions"
                    :radius="item.radius * 100000 || 1000" :id="item.id" :key="item.id + '_circle'"
                    :obj="item" :defaultStyle="circleStyle(item)" />
            </template>
        </LVector>
        <el-popover placement="right" width="298px" trigger="click" @hide="showKakouDialog = false"
            v-model="showKakouDialog" popper-class="emergency-tooltip">
            <!-- <kakouDialog :closeFn="() => (showKakouDialog = !showKakouDialog)"></kakouDialog> -->
            <div slot="reference" :style="style"></div>
        </el-popover>
        <el-popover v-if="!showKakouDialog" placement="right" width="298px" trigger="click" :visible-arrow="false"
            v-model="showCloseBtn"
            :popper-class="showWarnLineDialog ? 'emergency-tooltip' : 'emergency-tooltip point-info'" @hide="
                (showCloseBtn = false),
                (showWarnLineDialog = false),
                (showKakouDialog = false),
                (temp = false)
                ">
            <div style="width: 24px" @click.stop="clickFn">
                <div ref="ol-point-close" v-if="showCloseBtn && !showWarnLineDialog"
                    class="ol-point-close el-icon-circle-close" @click.stop="showDelDialogFn"></div>
            </div>
            <warn-line-dialog ref="warn-line-dialog" v-if="showCloseBtn && showWarnLineDialog && !sceneInfo"
                :showDialog="showWarnLineDialog" @closeShowDialog="showWarnLineDialog = false"
                :setLineWidth="editLineWidth"></warn-line-dialog>

            <pollutant-dialog v-if="showCloseBtn && showWarnLineDialog && sceneInfo" :showDialog="showWarnLineDialog"
                @closeShowDialog="showWarnLineDialog = false" :sceneInfo="sceneInfo"
                :editSceneInfo="editSceneInfo"></pollutant-dialog>
            <div slot="reference" :style="style"></div>
        </el-popover>
    </div>
</template>
<script>
import {
    LLineFeature,
    LVector,
    LPolygonFeature,
    LPointFeature,
    OMapMixin,
    LCircleFeature,
} from '@OpenLayersCommon';
import { Style, Stroke, Circle as CircleStyle, Icon } from 'ol/style';
import { LineString, Polygon, Point } from 'ol/geom';
import warnLineDialog from './ol-point/compontents/warn-line-dialog.vue';
import pollutantDialog from './ol-point/compontents/pollutant-dialog.vue';
import api from '../api/index';

export default {
    mixins: [OMapMixin],
    props: {
        caseCanvasList: Array,
    },
    components: {
        LVector,
        LPointFeature,
        LLineFeature,
        LPolygonFeature,
        warnLineDialog,
        pollutantDialog,
        LCircleFeature,
    },
    data () {
        return {
            showCloseBtn: false,
            showWarnLineDialog: false,
            showKakouDialog: false,
            mapZoom: 14.5,
            scale: null,
            style: {
                position: 'absolute',
                top: '100px',
                left: '200px',
            },
            dialongStyle: {
                position: 'absolute',
                top: '100px',
                left: '200px',
                'z-index': 9999,
            },
            selectId: null,
            flagTime: null,
            curPoint: null,
            hoverIncidentObj: {},
            sceneInfo: null, // 场景信息
            temp: false,
        };
    },

    async mounted () {
        let map = await this.getMap();
        this.map = map;
        this.changeZoom();
        // 更新zoom
        this.map.getView().on('change:resolution', this.changeZoom);
    },
    beforeDestroy () {
        this.map && this.map.getView().un('change:resolution', this.changeZoom);
    },
    watch: {
        caseCanvasList: {
            handler (newVal) {
                // console.log('caseCanvasList2222222', newVal);
            },
            immediate: true,
            deep: true,
        },
        showWarnLineDialog (val) {
            if (!val) {
                this.curPoint = null;
                this.sceneInfo = null;
                this.showCloseBtn = false;
            }
        },
        mapZoom () {
            let mapZoom = this.mapZoom;
            let scale = (mapZoom - 13) * 0.2 + 0.6;
            if (scale < 0.6) scale = 0.6;
            if (scale > 1) scale = 1;
            this.scale = scale;
        },
    },
    methods: {
        movestartMap () {
            this.showCloseBtn = false;
        },
        async editSceneInfo (info) {
            let params = { ...this.curPoint };
            Object.keys(info).forEach((key) => {
                params[key] = info[key];
            });
            params.json = JSON.stringify(params.json);
            // console.log('editSceneInfo', params);

            // await api.saveDrawInfo(params).run();
            // this.$emit('bindCaseList');
            // this.showWarnLineDialog = false;
        },
        async editLineWidth (width) {
            let params = { ...this.curPoint };
            params.width = width;
            params.json['3d'].width = width;
            params.json = JSON.stringify(params.json);
            await api.saveDrawInfo(params).run();
            this.$emit('bindCaseList');
            this.showWarnLineDialog = false;
        },
        showDelDialogFn () {
            this.$confirm('此操作将永久删除该标记, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    this.deleteFn();
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除',
                    });
                });
        },
        async deleteFn () {
            // console.log('this.selectId', this.selectId);
            if (this.selectId) {
                api.delCaseCanvas(this.selectId).then((res) => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功',
                        });
                        this.$emit('bindCaseList');
                        this.showCloseBtn = false;
                    }
                });
            }
        },
        hoverFeature (e, id, feature, obj) {
            if (this.showCloseBtn || this.showKakouDialog || e === null) return;
            // console.log('hoverFeature', e, id, feature, obj);

            let [x, y] = e.pixel_;
            this.style.top = `${y - 10}px`;
            this.style.left = `${x + 10}px`;
            if (obj) {
                this.hoverIncidentObj = {
                    e,
                    id,
                    feature,
                    obj,
                };
                if (this.curPoint && this.curPoint.id !== obj.id) {
                    this.showCloseBtn = false;
                }
                this.curPoint = obj;
                setTimeout(() => {
                    this.selectId = obj.id;
                    this.showCloseBtn = true;
                }, 50);
            } else {
                // if (this.showWarnLineDialog || this.sceneInfo || id === '雪糕筒') return;
                // this.showCloseBtn = false;
                // this.sceneInfo = null;
            }
        },
        clickFn () {
            let { e, id, feature, obj } = this.hoverIncidentObj;
            this.selectFeature(e, id, feature, obj);
        },
        selectFeature (e, id, feature, obj) {
            if (e === null) return;
            // console.log('hoverFeature', e, id, feature, obj);
            let [x, y] = e.pixel_;
            this.style.top = `${y - 10}px`;
            this.style.left = `${x - 0}px`;

            if (obj) {
                this.selectId = obj.id;
                if (obj.name.includes('道路') || obj.name.includes('形')) {
                    setTimeout(() => {
                        this.showCloseBtn = true;
                        this.temp = true;
                    }, 50);
                }
                if (obj.geometry.name === '卡口') {
                    setTimeout(() => {
                        this.showKakouDialog = true;
                    }, 50);
                }
                if (obj.geometry.name === '警戒线') {
                    setTimeout(() => {
                        this.showWarnLineDialog = true;
                        this.showCloseBtn = true;
                        this.$nextTick(() => {
                            this.$refs['warn-line-dialog'].handleChange(this.curPoint.width);
                        });
                    }, 50);
                }
                if (obj.geometry.name === '拦截范围' || obj.geometry.name === '视频测流速' || obj.geometry.name === '视频测面积') {
                    this.sceneInfo = obj;
                    setTimeout(() => {
                        this.showWarnLineDialog = true;
                        this.showCloseBtn = true;
                    }, 50);
                }
            }
        },
        drawLineStringStyle (item) {
            let { rotationFirst, CoordinatesFirst } = item;
            let CoordinatesLast = item.geometry[item.geometry.length - 1];
            let CoordinatesLast2 = item.geometry[item.geometry.length - 2];
            const dx = CoordinatesLast2[0] - CoordinatesLast[0];
            const dy = CoordinatesLast2[1] - CoordinatesLast[1];
            const rotationLast = -Math.atan2(dy, dx);
            let styles;
            styles = [
                new Style({
                    stroke: new Stroke({
                        color: '#29FFF288',
                        width: 8,
                        lineCap: 'butt',
                        zIndex: 20,
                    }),
                }),
                new Style({
                    geometry: new Point(CoordinatesLast),
                    image: new Icon({
                        src: require('./images/up.png'),
                        anchor: [1, 0.5],
                        rotateWithView: true,
                        rotation: rotationLast,
                    }),
                    zIndex: 21,
                }),
                new Style({
                    geometry: new Point(CoordinatesFirst),
                    image: new Icon({
                        src: require('./images/bottom.png'),
                        anchor: [0.01, 0.5],
                        rotateWithView: true,
                        rotation: rotationFirst,
                        // offset: [10, 0],
                    }),
                    zIndex: 21,
                }),
            ];
            return styles;
        },
        roadStyle (feature, resolution) {
            let styles = [];
            styles.push(
                new Style({
                    stroke: new Stroke({
                        color: '#FF3D0088',
                        width: 15 * this.scale,
                        lineCap: 'butt',
                    }),
                }),
            );
            // 线条样式
            let geometry = feature.getGeometry();
            // 获取线段长度
            const length = geometry.getLength();
            // 箭头间隔距离（像素）
            const step = 40;
            // 将间隔像素距离转换成地图的真实距离
            const StepLength = step * resolution;
            // 得到一共需要绘制多少个 箭头
            const arrowNum = Math.floor(length / StepLength);
            const rotations = [];
            const distances = [0];
            geometry.forEachSegment((start, end) => {
                let dx = end[0] - start[0];
                let dy = end[1] - start[1];
                let rotation = Math.atan2(dy, dx);
                distances.unshift(Math.sqrt(dx ** 2 + dy ** 2) + distances[0]);
                rotations.push(rotation);
            });
            // 利用之前计算得到的线段矢量信息，生成对应的点样式塞入默认样式中
            // 从而绘制内部箭头
            for (let i = 1; i < arrowNum; ++i) {
                const arrowCoord = geometry.getCoordinateAt(i / arrowNum);
                const d = i * StepLength;
                const grid = distances.findIndex((x) => x <= d);
                styles.push(
                    new Style({
                        geometry: new Point(arrowCoord),
                        image: new Icon({
                            src: require('./images/icon-road.png'),
                            opacity: 1,
                            anchor: [0.5, 0.5],
                            rotateWithView: false,
                            // 读取 rotations 中计算存放的方向信息
                            rotation: -rotations[distances.length - grid - 1],
                            scale: this.scale,
                        }),
                    }),
                );
            }

            return styles;
        },
        circleStyle (item) {
            return {
                fill: {
                    color: item.fillColor,
                },
                stroke: {
                    color: item.color,
                    width: item.width,
                },
            };
        },
        drawPolygonStyle (item) {
            let obj = {
                fill: {
                    color: '#FFFFFF10',
                },
                stroke: {
                    color: '',
                    width: '',
                },
            };
            if (item.name.includes('一级')) {
                obj.stroke = {
                    color: '#d6550d',
                    width: 2,
                };
            } else if (item.name.includes('二级')) {
                obj.stroke = {
                    color: '#d3ad28',
                    width: 3,
                };
            } else if (item.name.includes('三级')) {
                obj.stroke = {
                    color: '#78cb0e',
                    width: 4,
                };
            }

            // console.log('drawPolygonStyle', obj);
            return obj;
        },
        drawPointStyle (name) {
            let type = name.split('-')[0];
            return {
                stroke: {
                    color: '#00FF00',
                    width: 4,
                },
                icon: {
                    src: this.getImg(type),
                    scale: this.scale,
                    anchor: type === '燃烧点' ? [0.5, 0.5] : [0.5, 0.9],
                },
            };
        },
        changeZoom (evt) {
            const zoom = this.map.getView().getZoom(); // 获取当前地图的缩放级别
            this.mapZoom = zoom;
        },
        destroyed () {
            // console.log('=============没了');
        },
        getImg(type) {
            let img = '';
            switch (type) {
                case '起点':
                    img = require('./images/icon-start.png');
                    break;
                case '终点':
                    img = require('./images/icon-end.png');
                    break;
                case '卡口':
                    img = require('./images/icon-kakou.png');
                    break;
                case '嫌疑人':
                    img = require('./images/icon_suspicion-user.png');
                    break;
                case '燃烧点':
                    img = require('./images/icon-fire.png');
                    break;
                default:
                    img = require('./images/icon-fire.png');
                    break;
            }
            return img;
        },
    },
};
</script>

<style lang="scss">
.el-popper.emergency-tooltip,
.el-tooltip__popper.emergency-tooltip {
    color: white;
    padding: 0;
    background: rgba(7, 17, 80, 0.75);
    border: 1px solid #49f0fdff;
    border-radius: 4px 4px 0 0;
    box-shadow: none;
}

.el-tooltip__popper.emergency-tooltip-active {
    border: 0;
}

.el-popper.point-info {
    background: transparent;
    border: 0;
    text-align: right;
}

.el-tooltip__popper[x-placement^='right'].emergency-tooltip .popper__arrow::after {
    border-right-color: #49f0fdff;
}

.el-popper[x-placement^='right'].emergency-tooltip .popper__arrow::after {
    border-right-color: #49f0fdff;
}
</style>
<style lang="scss" scoped>
.ol-point-close {
    font-size: 25px;
    color: #fff;
    cursor: pointer;
}

.ol-tooltip-draw {
    width: 70px;
    height: 26px;
    text-align: center;
    line-height: 26px;
    font-size: 14px;
    color: #fff;
    background: rgba(11, 17, 23, 0.6);
    box-shadow: inset 0px 1px 9px 0px #ff8300;
    border-radius: 15px 15px 15px 15px;
    border: 1px solid #eb2c08;
}

.point-top {
    padding: 0 10px;
    height: 26px;
    line-height: 26px;
    color: #fff;
    text-align: center;
    font-size: 14px;
    border-radius: 15px 15px 15px 15px;

    background: rgba(7, 17, 80, 0.7);
    box-shadow: inset 0px 0px 16px 0px rgba(73, 240, 253, 0.8);
    border: 1px solid #49f0fd;

    .user-icon-svg {
        filter: drop-shadow(red 0px 0);
    }

    &.danger {
        background: rgba(152, 17, 2, 0.6);
        border: 1px solid #ff2d15;
        box-shadow: inset 0px 1px 9px 0px rgba(255, 45, 21, 0.4);
    }

    &.active-1 {
        background: rgba(7, 17, 80, 0.7);
        box-shadow: inset 0px 0px 16px 0px rgba(73, 240, 253, 0.8);
        border: 1px solid #49f0fd;
    }

    &.active-2 {
        background: rgba(7, 17, 80, 0.7);
        box-shadow: inset 0px 0px 16px 0px rgba(255, 237, 68, 0.7);
        border: 1px solid #ffed44;
    }

    &.active-3 {
        background: rgba(7, 17, 80, 0.7);
        box-shadow: inset 0px 0px 16px 0px rgba(255, 255, 255, 0.8);
        border: 1px solid #ffffff;
    }

    &.active-hover-1 {
        background: rgba(7, 17, 80, 0.7);
        box-shadow: inset 0px 0px 16px 0px rgba(73, 240, 253, 0.9);
        border: 2px solid #49f0fd;
    }

    &.active-hover-2 {
        background: rgba(7, 17, 80, 0.7);
        box-shadow: inset 0px 0px 16px 0px #ffed44;
        border: 2px solid #ffed44;
    }

    &.active-hover-3 {
        background: rgba(7, 17, 80, 0.7);
        box-shadow: inset 0px 0px 16px 0px rgba(255, 255, 255, 0.9);
        border: 2px solid #ffffff;
    }

    span {
        display: inline-block;
        width: 1px;
        height: 11px;
        margin: 0 5px;
        background-color: #fff;
    }
}

.point-distance {
    font-size: 14px;
    color: #fff;
    // width: 37px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: rgba(7, 17, 80, 0.7);
    box-shadow: inset 0px 1px 12px 0px rgba(26, 71, 164, 0.65);
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #49f0fd;
    padding: 0 5px;
}
</style>
